import styles from './styles.module.scss';

const Body3 = ({ className = '', text = '' }) => {
    return <span className={`${className} ${styles.body3}`}>{text}</span>;
};

export default Body3;
